// @flow
import React from "react";
import { connect } from "react-redux";
import { fetchForSaleProperties } from "./ducks";
import { Filters } from "./Filters";
import { PropertyList } from "./PropertyList";
import { type PropertyType } from "../PropertyCarousel/Property";

type ForSaleProps = {
  properties: PropertyType[],
};

type ForSaleState = {
  locationFilter: string,
};

export class ForSaleListComponent extends React.PureComponent<
  ForSaleProps,
  ForSaleState,
> {
  static fetchData = fetchForSaleProperties;

  render() {
    const { properties } = this.props;
    return (
      <div data-test="slice:for-sale-list">
        <Filters properties={properties}>
          {(filteredProperties, { loading, resetFilters }) => (
            <PropertyList
              loading={loading}
              properties={filteredProperties}
              resetFilters={resetFilters}
            />
          )}
        </Filters>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  properties: state.forSalePage.forSaleProperties || [],
});

export const ForSaleList = connect<ForSaleProps, {||}, _, _, _, _>(
  mapStateToProps,
)(ForSaleListComponent);
